import React from "react";
import { trim } from '_helpers';
import { FaXTwitter } from 'react-icons/fa6'

export function generateFollowerParams(following) {
  let arrayIds = []
  if (following) {
    for (let user = 0; user < following.length; user++) {
      const id = following[user].followed_id
      // console.log("id", id )
      arrayIds.push(id)

    }

  }
  let result = arrayIds.join()
  return result
}

export function getMaxFollowers(followers, addPadding = true, darkMode = false, forceCenter = false) {
  let facebook = Number(followers.Facebook) || 0;
  let instagram = Number(followers.Instagram) || 0;
  let twitter = Number(followers.Twitter) || 0;
  let youtube = Number(followers.Youtube) || 0;

  const max = Math.max(facebook, instagram, twitter, youtube);

  if (max === 0) {
    console.log("No followers. don't display", facebook, instagram, twitter, youtube, max)
    return <span />
  } else if (facebook === max) {
    return (
      <div className={(forceCenter ? "text-center " : "text-left ") + (addPadding ? "pt-2 mt-1" : "")} >
        <i className="fab fa-facebook" style={{ color: darkMode === true ? '#fff' : '#1877f2', fontSize: '16px', transform: 'translateY(1px)' }} />
        &nbsp;&nbsp;
        <small className={darkMode === true ? "text-white" : ""}>{trim(facebook)} </small>
      </div>
    )
  } else if (instagram === max) {
    return (
      <div className={(forceCenter ? "text-center " : "text-left ") + (addPadding ? "pt-2 mt-1" : "")} >
        <i className="fab fa-instagram" style={{ color: darkMode === true ? '#fff' : 'rgb(40, 40, 40)', fontSize: '16px', transform: 'translateY(1px)' }} />
        &nbsp;&nbsp;
        <small className={darkMode === true ? "text-white" : ""}>{trim(instagram)} </small>
      </div>
    )
  } else if (twitter === max) {
    return (
      <div className={(forceCenter ? "text-center " : "text-left ") + (addPadding ? "pt-2 mt-1" : "")} >
        <FaXTwitter color={darkMode === true ? "#fff" : '#000'} size={16} />
        &nbsp;&nbsp;
        <small className={darkMode === true ? "text-white" : ""}>{trim(twitter)} </small>
      </div>
    )
  } else if (youtube === max) {
    return (
      <div className={(forceCenter ? "text-center " : "text-left ") + (addPadding ? "pt-2 mt-1" : "")} >
        <i className="fab fa-youtube" style={{ color: darkMode === true ? '#fff' : 'rgb(255, 23, 23)', fontSize: '16px', transform: 'translateY(1px)' }} />
        &nbsp;&nbsp;
        <small className={darkMode === true ? "text-white" : ""}>{trim(youtube)} </small>
      </div>
    )
  } else {
    console.log("no max", facebook, instagram, twitter, youtube, max)
    return <span />
  }
}

